import React, { useState } from 'react';
import axios from 'axios';

function Login({ setUser }) {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');

  const handleLogin = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post('/api/auth/login', { email, password });
      setUser(res.data.user);
    } catch (err) {
      setError(err.response?.data?.error || 'Login fehlgeschlagen');
    }
  };

  return (
    <div style={styles.container}>
      <div style={styles.box}>
        <img src="/logo.jpg" alt="EliteHomes" style={styles.logo} />
        <h2 style={styles.title}>Notariats Angaben</h2>
        {error && <p style={styles.error}>{error}</p>}
        <form onSubmit={handleLogin}>
          <input
            style={styles.input}
            type="email"
            placeholder="E-Mail"
            value={email}
            onChange={e => setEmail(e.target.value)}
            required
          />
          <input
            style={styles.input}
            type="password"
            placeholder="Passwort"
            value={password}
            onChange={e => setPassword(e.target.value)}
            required
          />
          <p style={{ fontSize: '11px', color: '#999', marginTop: '-8px', marginBottom: '12px', textAlign: 'left' }}>Mind. 8 Zeichen, 1 Grossbuchstabe, 1 Zahl</p>
          <button style={styles.button} type="submit">Einloggen</button>
        </form>
      </div>
    </div>
  );
}

const styles = {
  container: {
    display: 'flex', justifyContent: 'center', alignItems: 'center',
    height: '100vh',
  },
  box: {
    backgroundColor: 'rgba(255,255,255,0.95)', padding: '40px', borderRadius: '8px',
    boxShadow: '0 2px 20px rgba(0,0,0,0.1)', width: '360px', textAlign: 'center',
  },
  logo: { width: '150px', height: 'auto', marginBottom: '16px' },
  title: { marginBottom: '24px', color: '#333', fontSize: '20px' },
  input: {
    width: '100%', padding: '12px', marginBottom: '12px',
    border: '1px solid #ddd', borderRadius: '4px', fontSize: '14px',
    boxSizing: 'border-box',
  },
  button: {
    width: '100%', padding: '12px', backgroundColor: 'rgb(50,180,170)',
    color: '#fff', border: 'none', borderRadius: '4px',
    fontSize: '16px', cursor: 'pointer',
  },
  error: { color: 'red', textAlign: 'center', marginBottom: '12px' },
};

export default Login;